<template>
<div class="GradeSetting spackage bgc padding-20 box-shadow">
    <div class="flex grade-head">
        <div class="flex">
            <p>开启等级</p>
            <el-switch v-model="isopenlevel" @click.native="startIsopenlevel"></el-switch>
        </div>
        <div class="flex">
            <p>开启头衔</p>
            <el-switch v-model="isopenlevelname" @click.native="startIsopenlevelname"></el-switch>
        </div>
       <div class="flex right">
            <span>关闭等级情况下，站点有关于等级的权限将失效；如指定等级阅读帖子等功能</span>
            <el-button type="primary" @click="initData">使用默认等级</el-button>
       </div>
    </div> 
    <div>
        <p style="margin-bottom: 20px">最多可以添加19个等级</p>
        <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column  width="50" label="级别">
            <!-- type="index" -->
            <template slot-scope="scope">
                {{scope.row.levelid}}
            </template>
            </el-table-column>
            <el-table-column label="图标" width="120">
                <template slot-scope="scope">

                    <template v-if="scope.row.levellogourl">
                        <div class="gradeimg"><p>LV<span>{{scope.row.levelid}}</span></p><img :src="scope.row.levellogourl" alt=""></div>
                    </template>
                    <!-- levellogourl 存在直接展示 -->

                    <template v-else>
                        <div class="gradeimg" v-if="scope.row.levelid === 1"><p>LV<span>{{scope.row.levelid}}</span></p><img src="./../../common/images/grade/grade-1.png" alt=""></div>
                        <div class="gradeimg" v-else-if="scope.row.levelid >= 2 && scope.row.levelid < 5"><p>LV<span>{{scope.row.levelid}}</span></p><img src="./../../common/images/grade/grade-2.png" alt=""></div>
                        <div class="gradeimg" v-else-if="scope.row.levelid >= 5 && scope.row.levelid < 8"><p>LV<span>{{scope.row.levelid}}</span></p><img src="./../../common/images/grade/grade-3.png" alt=""></div>
                        <div class="gradeimg" v-else-if="scope.row.levelid >= 8 && scope.row.levelid < 11"><p>LV<span>{{scope.row.levelid}}</span></p><img src="./../../common/images/grade/grade-4.png" alt=""></div>
                        <div class="gradeimg" v-else-if="scope.row.levelid >= 11 && scope.row.levelid < 14"><p>LV<span>{{scope.row.levelid}}</span></p><img src="./../../common/images/grade/grade-5.png" alt=""></div>
                        <div class="gradeimg" v-else-if="scope.row.levelid >= 14 && scope.row.levelid < 17"><p>LV<span>{{scope.row.levelid}}</span></p><img src="./../../common/images/grade/grade-6.png" alt=""></div>
                        <div class="gradeimg" v-else><p>LV<span>{{scope.row.levelid}}</span></p><img src="./../../common/images/grade/grade-7.png" alt=""></div>
                    </template>
                    <!-- levellogourl 不存在 为新增等级 前台控制展示-->

                    <!-- ="scope.$index>= 16 && scope.$index < 19" -->
                </template>
            </el-table-column>
            <el-table-column label="经验下限">
                <template slot-scope="scope">
                    <el-input placeholder="请输入经验下限" v-model="scope.row.minexpvalue" style="width: 246px"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="头衔">
                <template slot-scope="scope">
                    <el-input placeholder="请输入头衔（最多10字）" v-model="scope.row.levelname" maxlength="10" style="width: 246px"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="right">
                 <template slot-scope="scope">
                    <span class="del" @click="delItemSelection(scope.row.id, scope.$index)">删除</span>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin-top: 20px;margin-bottom: 60px;">
            <el-checkbox v-model="selection" @change="toggleSelection()">全选</el-checkbox>
            <span>已选 {{multipleSelection.length}} 个</span>
            <el-button style="margin-left: 20px;" type="primary" @click="delAllSelection()">批量删除</el-button>
        </div>
        <div class="btnlist">
            <el-button type="info" v-if="tableData.length >= 19" :disabled="true">新增等级</el-button>
            <el-button type="primary" v-else @click="addSelectionItem">新增等级</el-button>
            <el-button @click="submit">保存</el-button>
        </div>
    </div>

</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getStarLevelconfig, getDefaultLevel, saveOrUpdateStarlevelconfig, saveOrUpdateHoststarconfig} from '@/api/starMgtApi'
export default {
    name: 'GradeSetting',
    data() {
        return {
            selection: false, // 选择状态
            isopenlevel: true,   // 等级状态 
            isopenlevelname: true,   // 头衔状态
            tableData: [],  //  表单数据
            maxlevel: 0,    // 当前最大等级
            multipleSelection: [],  // 选中数据
            delid: [],  // 记录删除的id
        }
    },
    mounted() {
        this.initTable()
    },
    methods: {
        initTable(type) {    //  初始化表单与按钮数据 type 存在时按需加载数据 1 等级 2 头衔 3 刷新表单数据
            this.setLoading(true)
            getStarLevelconfig({
                data: {},
                success: data => {

                    /**
                     * 返回数据
                     * id：等级id；
                     * levelid：等级数；
                     * levellogourl：等级图标；
                     *  minexpvalue：经验下限；
                     * levelname：头衔名称；
                     * maxlevel：当前最大等级；
                     * isopenlevel：是否开启头衔(0 否 1是)；
                     * isopenlevelname：是否开启经验(0 否 1是)；
                     *  */ 

                    this.setLoading(false)

                    // 类别判断 存在 渲染类型 且 为1与2的情况下 只渲染部分数据
                    if (type && type === 1 || type === 2) {
                        this.isopenlevelname = data.data.isopenlevelname === 0?false:true   // 头衔状态
                        this.isopenlevel = data.data.isopenlevel === 0?false:true  // 等级状态 
                    } else {
                        this.tableData = data.data.datalist
                        this.isopenlevelname = data.data.isopenlevelname === 0?false:true   // 头衔状态
                        this.isopenlevel = data.data.isopenlevel === 0?false:true  // 等级状态 
                        this.maxlevel = data.data.maxlevel
                    }
                    
                },
                error: data => {
                     this.setLoading(false)
                     this.$message.error(data.msg)
                }
            })
        },
        addSelectionItem() {    // 增加等级
            
            // 增加等级
            this.maxlevel += 1

            this.tableData.push({  // 新增等级默认数据配置
                id: '', // 等级id
                levelid: this.maxlevel, // 级别
                levelname: '',  // 头衔
                minexpvalue: 0  // 经验下限
            })
        },
        toggleSelection() { // 全选列表 / 取消全选列表
            if (this.selection) {   // 全选状态
                this.tableData.forEach(row => { // 遍历列表
                    this.$refs.multipleTable.toggleRowSelection(row);   // 增加数据进选中列表
                });
            } else {
                this.$refs.multipleTable.clearSelection();  // 清空全部选中数据
            }
        },
        delItemSelection(id, index) {  // 删除单个等级

            // 有id 情况下 查找id 进行删除 无 id 情况通过下标删除
                if (id) {
                    for (let i = 0; i < this.tableData.length; i++) {   // 遍历表单数据
                        if (this.tableData[i].id === id) {
                            
                            // 记录本地删除元素id
                            this.delid.push(id)
                            
                            // 删除列表数据
                            this.tableData.splice(i,1)
                        }
                    }
                } else {
                    // 删除列表数据
                    this.tableData.splice(index,1)
                }
        },
        delAllSelection() { // 删除多个等级
            this.$confirm('确定批量删除这些等级吗？','提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                
                // 进行批量删除 遍历选中数据
                for (let i = 0; i < this.multipleSelection.length; i++) {
                    // 编辑表单数据
                    for (let j = 0; j < this.tableData.length; j++) {
                        // 取得数据
                        let mvalue = this.multipleSelection[i],
                            mtable = this.tableData[j]

                        // 判断 数据 id、经验下限、级别 是否相同
                        if (mvalue.id === mtable.id && mvalue.levelid === mtable.levelid && mvalue.minexpvalue === mtable.minexpvalue ) {
                            this.tableData.splice(j,1)

                            // 存储数据有id情况下，记录id
                            if(mvalue.id) {
                                this.delid.push(mvalue.id)
                            }
                            continue
                        }
                    }
                }
                    
                // this.$message.success('删除成功')
            }).catch(() => {})
        },
        initData() {    // 初始化默认数据 
            this.$confirm('使用默认等级后将清除现有配置，继续操作吗？','提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                getDefaultLevel({
                    data: {},
                    success: data => {
                        this.setLoading(false)
                        this.$message.success('操作成功')

                        // 更新数据
                        this.initTable()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        handleSelectionChange(val) {    // 表单全选状态控制
            // 全选数据
            this.multipleSelection = val;
            // 全选按钮状态显示
            if (val.length === 0) {
                this.selection = false
            } else {
                this.selection = true
            }
            // console.log(val)
        },
        startIsopenlevel() {    // 开启等级
            let data = {
                    "isopenlevel": this.isopenlevel  === true ? 1 : 0,
                    "isopenlevelname": this.isopenlevelname === true ? 1 : 0
                }

            // 为开启状态下 弹窗提示
            if (this.isopenlevel === false) {
                this.$confirm('确定要关闭等级吗？关闭等级后，用户的等级和经验信息就不会展示了','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    // 调用状态接口
                    this.saveOrUpdateHoststarconfig(data, 1)
                }).catch(() => {})
            } else {
                 // 调用状态接口
                this.saveOrUpdateHoststarconfig(data, 1)
            }
        },
        startIsopenlevelname() {    // 开启头衔
            let data = {
                    "isopenlevelname": this.isopenlevelname === true ? 1 : 0,
                    "isopenlevel": this.isopenlevel  === true ? 1 : 0
                }
            // 调用状态接口
            this.saveOrUpdateHoststarconfig(data, 2)
        },  
        saveOrUpdateHoststarconfig(datas, type) { // 修改等级设置 data 接口参数  type 操作类型，1 等级 2 头衔 3 刷新表单数据
            this.setLoading(true)
            saveOrUpdateHoststarconfig({
                data: datas,
                success: data => {
                    this.setLoading(false)
                    this.$message.success('操作成功')

                    // 数据渲染
                    this.initTable(type)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        submit() {  // 保存数

            this.$confirm('是否保存更新后的数据?','提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let tableData = this.tableData,
                    table = []

                for (let item in tableData) {
                    table.push(
                        {
                          id: tableData[item].id,
                          levelname: tableData[item].levelname,
                          minexpvalue: tableData[item].minexpvalue
                        }
                    )
                }

                this.setLoading(true)
                saveOrUpdateStarlevelconfig({
                    data: {rebatjson: JSON.stringify(table)},
                    success:datda => {
                        this.$message.success('保存成功')
                        this.setLoading(false)
                        this.initTable(3)
                    },
                    error:data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })

                // 更新成功情况下 清空删除数据id 与选中数据列表
                // this.delid = []
                this.multipleSelection = []

            }).catch(() => {})

        },
        // 开启头衔
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.GradeSetting {
    .flex {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
    }
    .grade-head {
        margin-bottom: 20px;
        .flex {
            margin-right: 30px
        }
        .right {
            justify-content: space-between;
            width: calc(100% - 303px);
        }
        .el-switch {
            margin-left: 10px
        }
        
        p,
        span {
            // margin-right: 30px;
            font-size: 14px
        }
        span {
            // margin-left: 30px;
            color: #909399
        }
        button {
            span {
                color: #fff
            }
        }
    }
    .del {
        cursor: pointer;
        color: #409EFF;
    }
    .gradeimg {
        position: relative;
        width: 69px;
        height: 28px;
        img {
            position: absolute;
            top: 0;
            width: 69px;
            height: 28px;
        }
        p {
            color: #fff;
            text-align: center;
            position: relative;
            z-index: 2;
            font-size: 12px;
            padding-top: 6px;
            margin-left: 24px;
            font-weight: bold;

            span {
                margin-left: 1px;
                color: #fff;
                font-size: 15px;
            }
        }
    }
    .btnlist {
        position: fixed;
        width: calc(100% - 180px);
        bottom: 0;
        text-align: center;
        background: #fff;
        padding: 15px 0;
        left: 180px;
        right: 0;
        z-index: 3;
        border-top: solid 1px #eee;
    }
}
</style>
